import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const Reveal = ({ children, delay = 0, className = "", y = 36 }) => (
  <motion.div
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-70px" }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    className={className}
  >
    {children}
  </motion.div>
);

export const ChapterHeading = ({ chapter, label, title, subtext, align = "left" }) => (
  <div className={align === "center" ? "text-center" : ""}>
    <Reveal>
      <div
        className={`flex items-center gap-4 ${align === "center" ? "justify-center" : ""}`}
        data-testid={`chapter-label-${chapter}`}
      >
        <span className="font-mono text-gold text-xs tracking-[0.3em]">{chapter}</span>
        <span className="h-px w-10 bg-gold/50" />
        <span className="font-mono text-gold text-xs uppercase tracking-[0.3em]">{label}</span>
      </div>
    </Reveal>
    <Reveal delay={0.1}>
      <h2 className="mt-6 font-serif text-3xl sm:text-4xl lg:text-5xl text-cream leading-tight">
        {title}
      </h2>
    </Reveal>
    {subtext && (
      <Reveal delay={0.2}>
        <p
          className={`mt-5 max-w-2xl text-mist text-base md:text-lg leading-relaxed ${
            align === "center" ? "mx-auto" : ""
          }`}
        >
          {subtext}
        </p>
      </Reveal>
    )}
  </div>
);
